import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import {Grid} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {LogsTypeTraductionKey} from "../../../logsType";
import Badge from "../../../../../../components/Badge";
import {grey300} from "../../../../../../assets/jss/main";
import {WMSContext} from "../../../../context/WMSContext";
import moment from "moment/moment";
import ArrowDownIcon from "../../../../../../components/icons/ArrowDownIcon";

LogWmsItem.propTypes = {
    item: PropTypes.object.isRequired
};

function LogWmsItem({item}) {
    const {isMobile} = useContext(WMSContext);

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ArrowDownIcon/>}>
                <Grid container direction={isMobile ? "column" : "row"} gap={"8px"} alignItems={"center"}>
                    <Badge color={"default"} rounded>
                        <span style={{fontSize: '1rem'}}>
                            {LogsTypeTraductionKey[item.event]
                                ? <FormattedMessage id={LogsTypeTraductionKey[item.event]}/>
                                : item.event
                            }
                        </span>
                    </Badge>
                    <p style={{fontSize: '0.8rem'}}>
                        {item.member?.user?.fullName}
                    </p>
                </Grid>
            </AccordionSummary>
            <AccordionDetails sx={{backgroundColor: grey300}}>
                <Grid
                    container
                    direction={"column"}
                    gap={"8px"}
                >
                    <Grid container alignItems={"center"} gap={"8px"}>
                        <FormattedMessage id={"wms.logs.wmsItems.status.label"}/>
                        <Badge>
                            <FormattedMessage id={`wms.logs.wmsItems.badge.status.${item.data.status}`}/></Badge>
                    </Grid>
                    <Grid container alignItems={"center"} gap={"8px"}>
                        <FormattedMessage id={"wms.logs.wmsItems.containerName.label"}/>
                        {item.data.wmsContainer && (
                            <>
                                <Badge>{item.data.wmsContainer?.fullName}</Badge>
                                <Badge color={"online"} rounded isBold>
                                    <FormattedMessage id={`wms.container.type.name.${item.data.wmsContainer.type}`}/>
                                </Badge>
                            </>
                        )}
                    </Grid>
                    <Grid container flexWrap={'nowrap'} alignItems={"center"}>
                        <span><FormattedMessage id={"wms.logs.wmsItems.updatedAt.label"}/></span>
                        <Badge color={"default"} rounded isBold>
                            {moment.utc(item.createdAt).local().format("DD/MM/YYYY HH:mm:ss")}
                        </Badge>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default LogWmsItem;